export default "__VITE_ASSET__C7HZPX5z__"